'use client';

import { lazy, Suspense, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { makeQueryClient } from '@/lib/react-query';

interface QueryProviderProps {
  children: React.ReactNode;
}

// Dynamically imported and dev-only so react-query-devtools (and its
// dependency tree) never ends up in the production bundle at all.
const ReactQueryDevtools =
  process.env.NODE_ENV !== 'production'
    ? lazy(() =>
        import('@tanstack/react-query-devtools').then((m) => ({ default: m.ReactQueryDevtools }))
      )
    : null;

export function QueryProvider({ children }: QueryProviderProps) {
  // Lazy useState initializer, not a module-level singleton — see
  // lib/react-query.ts for why a shared client is unsafe across requests
  // on the server.
  const [queryClient] = useState(() => makeQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {ReactQueryDevtools && (
        <Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} />
        </Suspense>
      )}
    </QueryClientProvider>
  );
}
